import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LegalizationFileDto } from 'src/app/models/legalization-file-dto';
import { FileService } from 'src/app/shared/services/file-service';

export interface LegalizationFilesModalData {
  LegalizationFiles: LegalizationFileDto[];
  WorkerId: number;
  DocumentTypeName: string;
}

@Component({
  selector: 'app-legalization-files-modal',
  templateUrl: './legalization-files-modal.component.html',
  styleUrls: ['./legalization-files-modal.component.scss'],
  standalone: false
})
export class LegalizationFilesModalComponent {
  dialogRef = inject<MatDialogRef<LegalizationFilesModalComponent>>(MatDialogRef);
  data = inject<LegalizationFilesModalData>(MAT_DIALOG_DATA);
  private fileService = inject(FileService);

  endpoint: string;

  constructor() {
    this.endpoint = `workers/${this.data.WorkerId}/files`;
  }

  downloadFile(legalizationFile: LegalizationFileDto): void {
    let name = legalizationFile.OriginalName ?? legalizationFile.Name;
    this.fileService.downloadFile(legalizationFile.Id, name, this.endpoint);
  }

  showFile(legalizationFile: LegalizationFileDto): void {
    let name = legalizationFile.OriginalName ?? legalizationFile.Name;
    this.fileService.showFile(name, legalizationFile.Id, this.endpoint, legalizationFile.FileContent);
  }

  onClose(): void {
    this.dialogRef.close(false);
  }
}
